import styled from 'styled-components';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';

export const LoginOptionContainer = styled(Anchor)`
  align-items: center;
  display: flex;
  justify-content: space-around;
  margin: 6px 0;
  padding: 16px;
`;
export const LoginIcon = styled.div`
  min-width: 40px;
  display: flex;
  align-items: center;
`;
export const LoginTextContent = styled.div`
  flex: 1;
`;
export const LoginHeading = styled(BodyCopy)``;
export const LoginSubHeading = styled(BodyCopy)``;
export const LoginArrow = styled.div``;
export const RightArrow = styled.span`
  border: solid black;
  border-width: 0 2px 2px 0;
  display: inline-block;
  padding: 6px;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
`;
